import {Component} from '@angular/core';
import {Tabs} from './tabs.component';

@Component({
    selector: 'tab',
    inputs: [
        'title:tabTitle',
        'name:tabName',
        'active'
    ],
    styles: [`
    .pane{
      padding: 1em;
    }
  `],
    template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
    </div>
  `
})
export class Tab {
    title:string;
    active:boolean = this.active || false;
    name:string;

    constructor(private tabs:Tabs) {
        tabs.addTab(this);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/tabs/tab.component.ts
 **/